export default {"src":"/_next/static/media/podcast-star-unfilled.a4c353fc.svg","height":23,"width":24};